import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";

export const exportPDF = async (
  rows,
  columns,
  startDate,
  endDate,
  reportType,
  facilityLogo
) => {
  const doc = new jsPDF("landscape", "mm", "a4");

  // Load logo
  const logoUrl = "/logo2.png";
  const logo = await loadImageBase64(logoUrl);

  const pageWidth = doc.internal.pageSize.getWidth();

  // --- Logo + Title (Aligned on same line) ---
  const logoWidth = 30;
  const logoHeight = 30;
  const topY = 0;

  // Add Logo
  doc.addImage(logo, "PNG", 10, topY, logoWidth, logoHeight);

  // Title
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  const titleY = topY + 15;
  doc.text(`${reportType}Report`, pageWidth / 2, titleY, { align: "center" });

  // ---- UNDERLINE TITLE ----
  const titleWidth = doc.getTextWidth(`${reportType}Report`);
  const underlineStart = pageWidth / 2 - titleWidth / 2;
  const underlineEnd = pageWidth / 2 + titleWidth / 2;
  doc.setLineWidth(0.5);
  doc.line(underlineStart, titleY + 2, underlineEnd, titleY + 2);

  let imageToUse = facilityLogo;

  // If it's AVIF → convert to PNG
  if (facilityLogo?.startsWith("data:image/avif")) {
    imageToUse = await convertAvifToPng(facilityLogo);
  }

  //facility logo
  doc.addImage(
    imageToUse,
    "PNG",
    pageWidth - logoWidth - 10, // right side padding
    topY + 8,
    logoWidth,
    15
  );

  // --- Paragraph with report type and dates ---
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  const paragraph = `${reportType}Report from ${convertUTCToTimeZoneDateTimeString(
    startDate
  )} to ${convertUTCToTimeZoneDateTimeString(endDate)}`;
  const paragraphY = titleY + 14; // slightly below title

  const leftMargin = 10; // margin from left
  doc.text(paragraph, leftMargin, paragraphY); // left-aligned with margin

  // --- Convert Columns & Rows ---
  const tableColumn = columns.map((col) => col.headerName);
  const tableRows = rows.map((row) => columns.map((col) => row[col.field]));

  // --- Table ---
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: paragraphY + 5, // start right after paragraph, reduce extra gap
    margin: { left: 10, right: 10 },
    styles: {
      fontSize: 6,
      cellPadding: 2,
      cellWidth: "wrap",
    },
    columnStyles: {
      2: { cellWidth: 15 },
      8: { cellWidth: 20 },
      10: { cellWidth: 10 },
    },
    tableWidth: "auto",
    theme: "grid",
  });

  // --- Bottom Right Timestamp ---
  const timeText = `Generated At: ${new Date().toLocaleString()}`;
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  const timeWidth = doc.getTextWidth(timeText);
  const pageHeight = doc.internal.pageSize.getHeight();
  doc.text(timeText, pageWidth - timeWidth - 10, pageHeight - 5);

  const timestamp = new Date().toLocaleString().replace(/\D/g, "");
  doc.save(`${reportType}Record-${timestamp}.pdf`);
};

// Convert image to Base64
const loadImageBase64 = (url) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
  });
};

async function convertAvifToPng(base64Avif) {
  const blob = await fetch(base64Avif).then((r) => r.blob());
  const bitmap = await createImageBitmap(blob);

  const canvas = document.createElement("canvas");
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0);

  return canvas.toDataURL("image/png");
}
